(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-policy-back-link]');
    if (!(link instanceof HTMLAnchorElement) || !document.referrer) return;

    try {
      if (new URL(document.referrer).origin !== window.location.origin) return;
    } catch {
      return;
    }

    event.preventDefault();
    window.history.back();
  });
})();
